import BurgerMenu from '../../../../drager/assets/scripts/components/hamburger';
import CookieBar from '../../../../drager/assets/scripts/components/cookie-bar';
import HoverEffect from '../../../../drager/assets/scripts/components/hover-effect';
import MobileMenu from '../components/mobile-menu';
import Modal from '../../../../drager/assets/scripts/components/modal';
import Milestones from '../components/milestones';
import NewsBlock from '../../../../drager/assets/scripts/components/news-block';
import Header from '../../../../drager/assets/scripts/components/header';
import EntriesWithImage from '../components/post-entries-with-image';
import Animation from '../../../../drager/assets/scripts/components/animation';
import Responsive from '../../../../drager/assets/scripts/components/responsive';
import ProductComparison from '../components/product-comparison';
import Dropdown from '../components/dropdown';
import triggerEvent from '../../../../drager/assets/scripts/components/tracking';

export default {
  init() {
    this.Responsive = new Responsive();
    this.Header = new Header();
    this.Animation = new Animation();
    this.coookieBar = new CookieBar();
    this.BurgerMenu = new BurgerMenu();
    this.HoverEffect = new HoverEffect();
    this.MobileMenu = new MobileMenu();
    this.Milestones = new Milestones();
    this.Modal = new Modal();
    this.NewsBlock = new NewsBlock();
    this.EntriesWithImage = new EntriesWithImage();
    this.ProductComparison = new ProductComparison();
    this.Dropdown = new Dropdown();
    this.addEvents();
    this.modifyDOM();
  },

  addEvents() {
  },

  modifyDOM() {
  },
};
